import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";

import "../daterangepicker.css";
import "../Usuarios/usuarios.css";
import "../../Forms.css";

import * as api from "helper/helper";
import { Sections } from "../../data/navItem";
import { PermissionsForSection } from "../auth";
import PagedFetch, {
  buildPageButtonsInfo,
  Init,
} from "../../helperFunctions/PagedFetch";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { getMonthNames, getYearsUntilNow } from "helper/tools";
import AsociadosKPITableSmall2 from "./AsociadosKPITableSmall2";

export default function AsociadosNuevosSmall() {
  const Menus = {
    Status: 0,
    Niveles: 1,
    LimiteCreditoRange: 2,
    CreditoRange: 3,
    CreditoDispuestoRange: 4,
    CreditoDisponibleRange: 5,
    Documentacion: 6,
  };

  const StatusValues = {
    Activo: 0,
    Inactivo: 1,
  };

  const DocumentacionValues = {
    Con: 0,
    Sin: 1,
  };

  const rangeCredito = useRef(null);

  const createAsociadosRef = useRef();
  const filtrosRef = useRef([]);
  const changeCreditLimitRef = useRef();
  const changeLevelRef = useRef();

  const dateRangeRef = useRef();
  const dateRangeEleRef = useRef();

  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const [status, setStatus] = useState([
    {
      nombre: "Activo",
      value: StatusValues.Activo,
      id: 1,
      pos: 0,
      checked: false,
    },
    {
      nombre: "Inactivo",
      value: StatusValues.Inactivo,
      id: 2,
      pos: 1,
      checked: false,
    },
    //  { nombre: "Draft", value: "draft", id: 3 },
  ]);

  const [docu, setDocu] = useState([
    {
      nombre: "Con",
      value: DocumentacionValues.Con,
      id: 1,
      pos: 0,
      checked: false,
    },
    {
      nombre: "Sin",
      value: DocumentacionValues.Sin,
      id: 2,
      pos: 1,
      checked: false,
    },
    //  { nombre: "Draft", value: "draft", id: 3 },
  ]);

  const [filtros] = useState([
    {
      type: Menus.Niveles,
      name: "Niveles",
    },
    {
      type: Menus.Status,
      name: "Estatus",
    },

    {
      type: Menus.Documentacion,
      name: "Documentación",
    },
    {
      type: Menus.LimiteCreditoRange,
      name: "Rango Limite Credito",
    },
    {
      type: Menus.CreditoRange,
      name: "Rango Credito Dispuesto",
    },
    {
      type: Menus.CreditoDispuestoRange,
      name: "Rango % Credito Dispuesto",
    },
    {
      type: Menus.CreditoDisponibleRange,
      name: "Rango Credito Disponible",
    },
  ]);

  /** FILTERS */
  const [kpiData, setKpiData] = useState([]);
  const [niveles, setNiveles] = useState([]);

  /** PAGING */
  const [searchCriteria, setSearchCriteria] = useState({});
  const [pageButtons, setPageButtons] = useState([Init.Vars.PageButtons]);

  const selectedDate = useRef(new Date());
  ///start changes CLASS
  const pagingInfoRef = useRef(new PagedFetch());
  const [responsePagingInfo, setResponsePagingInfo] = useState({
    ...Init.Vars.ResponsePagingInfo,
  });

  useEffect(() => {
    console.log("--->");

    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const daysBack7 = new Date(now);
    daysBack7.setDate(daysBack7.getDate() - 6);
    const daysBack30 = new Date(now);
    daysBack30.setDate(daysBack30.getDate() - 29);

    const thisMonthStart = new Date(now);
    thisMonthStart.setDate(1);
    const thisMonthEnd = new Date(thisMonthStart);
    thisMonthEnd.setMonth(thisMonthEnd.getMonth() + 1);
    thisMonthEnd.setDate(-1);

    const lastMonthStart = new Date(now);
    lastMonthStart.setDate(1);
    lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);
    const lastMonthEnd = new Date(lastMonthStart);
    lastMonthEnd.setMonth(lastMonthEnd.getMonth() + 1);
    lastMonthEnd.setDate(-1);

    const lastYearStart = new Date(now);
    lastYearStart.setDate(1);
    lastYearStart.setMonth(0);
    lastYearStart.setFullYear(lastYearStart.getFullYear() - 1);

    const lastYearEnd = new Date(lastYearStart);
    lastYearEnd.setFullYear(lastYearStart.getFullYear() + 1);
    lastYearEnd.setDate(-1);

    const sameMonthDifAge = new Date(now);
    sameMonthDifAge.setDate(sameMonthDifAge.getFullYear() - 1);

    dateRangeRef.current = new window.daterangepicker(
      dateRangeEleRef.current,
      {
        locale: {
          customRangeLabel: "Rango Personalizado",
        },
        singleDatePicker: true,
        showDropdowns: true,
        showCustomRangeLabel: true,

        minYear: 2020,
        maxYear: now.getFullYear(), // parseInt(moment().format('YYYY'),10)
        /*  ranges: {
          Hoy: [now, now],
          Ayer: [yesterday, yesterday],
          "Ultimos 7 Dias": [daysBack7, now],
          "Ultimos 30 Dias": [daysBack30, now],
          "Este mes": [thisMonthStart, thisMonthEnd],
          "Ultimo mes": [lastMonthStart, lastMonthEnd],
          "Ultimo Año": [lastYearStart, lastYearEnd],
        },*/
      },
      function (start, end, label) {
        //  var years = 23; //moment().diff(start, 'years');
        const date = start.toDate();
        selectedDate.current = date;
        fetchData();

        //  alert("You are " + years + " years old!");
      },
    );

    /*

    $(function() {

        var start = moment().subtract(29, 'days');
        var end = moment();

        function cb(start, end) {
            $('#reportrange span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
        }

        $('#reportrange').daterangepicker({
            startDate: start,
            endDate: end,
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            }
        }, cb);

        cb(start, end);

    });
    
    */
    /*
    .daterangepicker({
      timePicker: true,
      startDate: 22, //moment().startOf("hour"),
      endDate: 33, //moment().startOf("hour").add(32, "hour"),
      locale: {
        format: "M/DD hh:mm A",
      },
    });*/
    const date = new Date();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    setYearSelected(year);
    setMonthSelected(monthIndex);

    fetchData(monthIndex, date.getFullYear());

    const wideMonthNames = getMonthNames(es).map((month, index) => ({
      name: month,
      isSelected: monthIndex === index,
    }));
    setMonths(wideMonthNames);

    const yearNames = getYearsUntilNow(es).map((year) => ({
      name: year,
      isSelected: false,
    }));
    setYears(yearNames);

    const newPermissions = PermissionsForSection(Sections.Asociados);
    setPermissions(newPermissions);
  }, []);

  const fetchData = async (monthIndex, year) => {
    setIsLoading(true);

    const start = new Date();
    start.setMonth(monthIndex);
    start.setDate(1);
    start.setFullYear(year);

    const fechaInicial = format(start, "yyyy-MM-dd'T'00:00:00");

    const payload = {
      fechaIngreso: fechaInicial,
      sortAsc: true,
    };
    const responseNiveles = await api
      .dashboardAsociadosNuevos(payload)
      .catch((error) => {
        toast.error("Error al pedir Asociados Nuevos.");
        setIsLoading(false);
      });

    if (!responseNiveles) {
      setIsLoading(false);
      return;
    }

    setNiveles(responseNiveles.data);
    setIsLoading(false);
    /*
    let criteria = searchCriteria;
    /// reset pag info
    pagingInfoRef.current.resetPageInfo();

    criteria = pagingInfoRef.current.buildFetch(criteria);*/
    //searchFetchData(criteria);
  };

  function loadItem(item) {
    if (!permissions.canVerDetalle) return;

    console.log(createAsociadosRef);
    setModalData(item);

    createAsociadosRef.current.toggleModal();
  }

  const [months, setMonths] = useState([]);

  const [years, setYears] = useState([]);
  const [yearSelected, setYearSelected] = useState(null);
  const [monthSelected, setMonthSelected] = useState(null);

  //const monthSelected = useRef();
  const monthSelectRef = useRef();

  const yearSelectRef = useRef();

  const reporteSmallRef = useRef();

  function openChangeCreditLimit(event, data) {
    console.log(event);
    setModalData(data);
    changeCreditLimitRef.current.toggleModal();
  }

  function openChangeLevel(event, data) {
    console.log(event);
    setModalData(data);
    changeLevelRef.current.toggleModal();
  }

  /**
   * Search handler
   */
  const onChangeSearchText = (e) => {
    console.log("text search change " + e);

    let criteria = searchCriteria;

    if (e === null) {
      delete criteria["texto"];
    } else {
      criteria["texto"] = e;
    }

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);
  };

  function clearNivelesFilter(s) {
    niveles.forEach((item) => {
      item.checked = false;
    });

    setNiveles(niveles.slice());

    updateNivelesCriteria([]);

    filtrosRef.current[Menus.Niveles].hideMenu();
  }

  const handleNivelesClick = (event, item, options) => {
    let criteria = searchCriteria;
    let nivelIds = criteria["NivelIds"] ?? [];

    let itemId = item.id;
    if (event.currentTarget.checked && !nivelIds.includes(item.id)) {
      nivelIds.push(itemId);
    } else if (!event.currentTarget.checked && nivelIds.includes(item.id)) {
      nivelIds = nivelIds.filter((f) => f !== itemId);
    }

    updateNivelesCriteria(nivelIds);
  };

  const updateNivelesCriteria = (nivelIds) => {
    let criteria = searchCriteria;

    criteria["NivelIds"] = nivelIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Niveles;
    });

    if (index === -1) {
      return;
    }
    var nivelesNames = "";
    if (nivelIds.length > 0) {
      //
      const nivelesFilter = niveles.filter((currItem) => {
        return nivelIds.includes(currItem.id);
      });

      nivelesNames = nivelesFilter
        .map(function (depa) {
          return depa.nombre;
        })
        .join(", ");
    }

    filtrosRef.current[index].toka(nivelesNames);
  };

  function clearCreditoRange(s) {
    handleCreditoRangeChange("");
    filtrosRef.current[Menus.CreditoRange].hideMenu();
  }

  const handleCreditoRangeChange = (event, item, options) => {
    let criteria = searchCriteria;

    if (event.length > 0) {
      const aRange = event.split(",").map((str) => {
        return parseInt(str) * 1000;
      });

      rangeCredito.current = aRange;
      //currentStatus[item.pos] = event.currentTarget.checked;

      criteria["creditoRange"] = aRange;
    } else {
      delete criteria["creditoRange"];
    }

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.CreditoRange;
    });

    if (index === -1) {
      return;
    }

    filtrosRef.current[index].toka(event);
  };

  const clearDocumentacionFilter = () => {
    docu.forEach((item) => {
      item.checked = false;
    });

    setDocu(docu.slice());

    updateDocuCriteria(undefined);

    filtrosRef.current[Menus.Documentacion].hideMenu();
  };

  function clearLimiteCreditoRange(s) {
    handleLimiteCreditoRangeChange("");
    filtrosRef.current[Menus.CreditoRange].hideMenu();
  }

  function clearCreditoPercentageRange(s) {
    handleCreditoRangePercentageChange("");
    filtrosRef.current[Menus.CreditoDispuestoRange].hideMenu();
  }

  function clearCreditoDisponibleRange(s) {
    handleCreditoRangeDisponibleChange("");
    filtrosRef.current[Menus.CreditoDisponibleRange].hideMenu();
  }

  const handleLimiteCreditoRangeChange = (event, item, options) => {
    let criteria = searchCriteria;

    if (event.length > 0) {
      const aRange = event.split(",").map((str) => {
        return parseInt(str) * 1000;
      });

      rangeCredito.current = aRange;

      criteria["LimiteCreditoRange"] = aRange;
    } else {
      delete criteria["LimiteCreditoRange"];
    }

    /// reset pag info
    //pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);

    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.LimiteCreditoRange;
    });

    if (index === -1) {
      return;
    }

    filtrosRef.current[index].toka(event);
  };

  const handleCreditoRangePercentageChange = (event, item, options) => {
    let criteria = searchCriteria;

    if (event.length > 0) {
      const aRange = event.split(",").map((str) => {
        return parseInt(str);
      });

      rangeCredito.current = aRange;

      criteria["CreditoPorcentajeRange"] = aRange;
    } else {
      delete criteria["CreditoPorcentajeRange"];
    }

    /// reset pag info
    //pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);

    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.CreditoDispuestoRange;
    });

    if (index === -1) {
      return;
    }

    filtrosRef.current[index].toka(event);
  };

  const handleCreditoRangeDisponibleChange = (event, item, options) => {
    let criteria = searchCriteria;

    if (event.length > 0) {
      const aRange = event.split(",").map((str) => {
        return parseInt(str) * 1000;
      });

      rangeCredito.current = aRange;

      criteria["CreditoDisponibleRange"] = aRange;
    } else {
      delete criteria["CreditoDisponibleRange"];
    }

    /// reset pag info
    //pagingInfoRef.current.current.resetPageInfo();
    //criteria = pagingInfoRef.current.current.buildFetch(criteria);

    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.CreditoDisponibleRange;
    });

    if (index === -1) {
      return;
    }

    filtrosRef.current[index].toka(event);
  };

  function clearCallback(item) {
    filtros.forEach((value, index) => {
      if (value.type === Menus.Niveles && item.type === Menus.Niveles) {
        clearNivelesFilter();
      } else if (value.type === Menus.Status && item.type === Menus.Status) {
        clearStatusFilter();
      } else if (
        value.type === Menus.Documentacion &&
        item.type === Menus.Documentacion
      ) {
        clearDocumentacionFilter();
      } else if (
        value.type === Menus.LimiteCreditoRange &&
        item.type === Menus.LimiteCreditoRange
      ) {
        clearLimiteCreditoRange();
      } else if (
        value.type === Menus.CreditoRange &&
        item.type === Menus.CreditoRange
      ) {
        clearCreditoRange();
      } else if (
        value.type === Menus.CreditoDispuestoRange &&
        item.type === Menus.CreditoDispuestoRange
      ) {
        clearCreditoPercentageRange();
      } else if (
        value.type === Menus.CreditoDisponibleRange &&
        item.type === Menus.CreditoDisponibleRange
      ) {
        clearCreditoDisponibleRange();
      }
    });
  }

  const clearStatusFilter = () => {
    status.forEach((item) => {
      item.checked = false;
    });

    setStatus(status.slice());

    updateStatusCriteria(undefined);

    filtrosRef.current[Menus.Status].hideMenu();
  };

  const handleStatusClick = (event, item, options) => {
    item.checked = !item.checked;

    const isActivo = status.find((item) => {
      return item.value === StatusValues.Activo && item.checked;
    })?.checked;
    const isInactivo = status.find((item) => {
      return item.value === StatusValues.Inactivo && item.checked;
    })?.checked;

    let checked = isActivo;
    if (!(isActivo ^ isInactivo)) {
      //delete criteria["isActivo"];
      checked = undefined;
    } else {
      //let checked = isActivo;
      if (isInactivo) {
        checked = false;
      }
      //criteria["isActivo"] = checked;
    }

    updateStatusCriteria(checked);
  };

  const handleDocuClick = (event, item, options) => {
    item.checked = !item.checked;

    const isCon = docu.find((item) => {
      return item.value === DocumentacionValues.Con && item.checked;
    })?.checked;
    const isSin = docu.find((item) => {
      return item.value === DocumentacionValues.Sin && item.checked;
    })?.checked;

    let checked = isCon;
    if (!(isCon ^ isSin)) {
      //delete criteria["isActivo"];
      checked = undefined;
    } else {
      //let checked = isActivo;
      if (isSin) {
        checked = false;
      }
      //criteria["isActivo"] = checked;
    }

    updateDocuCriteria(checked);
  };

  const updateStatusCriteria = (statusValue) => {
    let criteria = searchCriteria;
    if (statusValue === undefined) {
      delete criteria["isActivo"];
    } else {
      criteria["isActivo"] = statusValue;
    }
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Status;
    });

    if (index === -1) {
      return;
    }
    var statusNames = "";
    //
    const statuses = status.flatMap((currItem, index) => {
      return currItem.checked ? currItem.nombre : [];
    });

    statusNames = statuses.join(", ");

    filtrosRef.current[index].toka(statusNames);
  };

  const updateDocuCriteria = (docuValue) => {
    let criteria = searchCriteria;
    if (docuValue === undefined) {
      delete criteria["HasDocumentacion"];
    } else {
      criteria["HasDocumentacion"] = docuValue;
    }
    setSearchCriteria(criteria);

    /// reset pag info
    //pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);

    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Documentacion;
    });

    if (index === -1) {
      return;
    }
    var docusNames = "";
    //
    const docuses = docu.flatMap((currItem, index) => {
      return currItem.checked ? currItem.nombre : [];
    });

    docusNames = docuses.join(", ");

    filtrosRef.current[index].toka(docusNames);
  };

  const searchFetchData = async (criteria) => {
    setIsLoading(true);

    const response = await api
      .asociadosKPIDataIntegrity(criteria)
      .catch((error) => {
        toast.error("Error al buscar Clientes.");
        setIsLoading(false);
      });
    if (!response) return;

    setKpiData(response.data.subset);

    const { totalPages, count, isFirstPage, isLastPage } = response.data;

    const { rangePage, newPageNumber } = buildPageButtonsInfo(response.data);
    pagingInfoRef.current.updatePageNumber(newPageNumber);

    setPageButtons(rangePage);

    setResponsePagingInfo({
      count,
      isFirstPage,
      isLastPage,
      pageNumber: newPageNumber,
      totalPages,
    });

    //  setAsociados(response.data.subset);

    setIsLoading(false);
  };

  function handleSortChange({ sortBy, sortAsc }) {
    if ((sortBy?.length ?? 0) === 0) {
      return;
    }
    let criteria = searchCriteria;
    criteria["sortBy"] = sortBy;
    criteria["sortAsc"] = sortAsc === "asc";

    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  return (
    <>
      <div className="">
        <div className="bd-example-row1">
          <div className="row">
            <div className="p-3 border bg-primary text-light report-card-title">
              <span>
                Asociados Nuevos
                <small className="text-muted"></small>
              </span>
            </div>
          </div>

          <div
            className=""
            style={{
              display: "flex",
              alignItems: "center",
              columnGap: "10px",
              width: "310px",
            }}
          >
            {/*  <input ref={dateRangeEleRef} type="text" name="daterange" /> */}

            <select
              className="form-select"
              aria-label="Default select example"
              value={monthSelected}
              onChange={(item) => {
                const monthIndex = parseInt(item.currentTarget.value);
                setMonthSelected(monthIndex);
                fetchData(monthIndex, yearSelected);
              }}
            >
              {months.map((item, index) => {
                return (
                  <option selected={item.isSelected} value={index}>
                    {item.name}
                  </option>
                );
              })}
            </select>

            <select
              className="form-select"
              aria-label="Default select example"
              value={yearSelected}
              onChange={(item) => {
                const year = parseInt(item.currentTarget.value);
                setYearSelected(item.currentTarget.value);
                //TODO  fetchData(monthIndex);
                yearSelectRef.current = year;
                //fetchData(monthIndex);

                fetchData(monthSelected, year);

                /*  reporteSmallRef.current.changeSelectedMonth(
                  monthSelectRef.current.value,
                  yearSelectRef.current,
                );*/
              }}
            >
              {years.map((item, index) => {
                return (
                  <option selected={item.isSelected} value={item.name}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="row">
            <AsociadosKPITableSmall2
              items={niveles}
              openItem={loadItem}
              isLoading={isLoading}
            />
          </div>
        </div>
        <div className="container  overflow-hidden"></div>
      </div>
    </>
  );
}
